import React, { useState, useContext } from 'react'
import { Form, Input, Button } from 'antd'
import styled from 'styled-components'
import { injectIntl, WrappedComponentProps } from 'react-intl'

import { Logo } from '../assets/Logo'
import { AuthContext } from '../Components/Auth/AuthContext'
import { FlexRow, FlexColumn } from '../Components/FlexboxReusables/FlexItems'
import { LanguageSwitcher } from '../i18n/LanguageSwitcher'

const LoginPage: React.FC<WrappedComponentProps> = (props) => {
  const [ email, setEmail ] = useState<string>('')
  const [ password, setPassword ] = useState<string>('')

  const { login } = useContext(AuthContext)
  
  const { intl } = props

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      login(email, password)
    }
  }

  const handleSubmit = () => {
    login(email, password)
  }
  
  return (
    <Container>
      <StyledForm>
        <HeaderWrapper>
          <Logo />
          <CourseWareText>CourseWare</CourseWareText>
        </HeaderWrapper>
        <FormItem>
          <Input
            placeholder={intl.formatMessage({ description: 'username', id: 'login.username' })}
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </FormItem>
        <FormItem>
          <InputField.Password
            placeholder={intl.formatMessage({ description: 'password', id: 'login.password' })}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            onKeyDown={handleKeyDown}
          />
        </FormItem>
        <FormItem>
          <FlexRow>
            <FlexColumn alignItems='flex-start'>
              <LoginButton type="primary" size="small" onClick={handleSubmit} style={{width: '50%'}}>
                {intl.formatMessage({ description: 'submit', id: 'login.submit' })}
              </LoginButton>
            </FlexColumn>
            <FlexColumn alignItems='flex-end'>
              <LanguageSwitcher />
            </FlexColumn>
          </FlexRow>
        </FormItem>
      </StyledForm>
    </Container>
  )
}

export default injectIntl(LoginPage)

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  max-width: 500px;
  margin-bottom: 15vh;
  padding: 40px;
  border: 2px solid #ddd;
  border-radius: 10px;
  background-color: #f0f2f5;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
`

const FormItem = styled(Form.Item)`
  margin-bottom: 20px;
  width: 100%;
`

const InputField = styled(Input)`
  width: 100%;
`

const LoginButton = styled(Button)`
  width: 20%;
`

const CourseWareText = styled.h1`
  margin-top: 10px;
  margin-left: 10px;
  font-size: 24px;
  font-weight: bold;
  color: #14CCAA;
`

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 70px;
`

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background: linear-gradient(to bottom, #14CCAA, #ffffff);
`